import {
  CHECKOUT_ITEM_TYPE_BEDBANK,
  CHECKOUT_ITEM_TYPE_CRUISE,
  CHECKOUT_ITEM_TYPE_EXPERIENCE,
  CHECKOUT_ITEM_TYPE_FLIGHT,
  CHECKOUT_ITEM_TYPE_LE_HOTEL,
  CHECKOUT_ITEM_TYPE_TOUR_V2,
  CHECKOUT_ITEM_TYPE_TRANSFER,
  CHECKOUT_ITEM_TYPE_VILLA,
} from 'constants/checkout'
import { WeddingGiftType, type WeddingGiftCategory } from 'weddings/api/weddings'
import type { CartItemData } from 'components/Pages/UserCartPage/SharedCarts/hooks/useAllUserMultiCartItemsMetadata'
import { DEFAULT_CUSTOM_OFFER_FLIGHT_IMAGE_ID } from 'constants/image'
import { isExperienceItem } from 'lib/checkout/checkoutUtils'
import { DISABLED_WEDDING_GIFT_TYPES } from 'weddings/constants/giftRegistry'

export function getWeddingGiftCategory(itemType: App.Checkout.AnyItemType): WeddingGiftCategory | undefined {
  switch (itemType) {
    case CHECKOUT_ITEM_TYPE_LE_HOTEL:
    case CHECKOUT_ITEM_TYPE_BEDBANK:
    case CHECKOUT_ITEM_TYPE_VILLA:
      return 'HOTEL'
    case CHECKOUT_ITEM_TYPE_FLIGHT:
      return 'FLIGHT'
    case CHECKOUT_ITEM_TYPE_EXPERIENCE:
    case CHECKOUT_ITEM_TYPE_TRANSFER:
      return 'EXPERIENCE'
    case CHECKOUT_ITEM_TYPE_CRUISE:
      return 'CRUISE'
    case CHECKOUT_ITEM_TYPE_TOUR_V2:
      return 'TOUR'
    case 'merchandise':
      return 'ANY'
  }
}

export function getWeddingGiftType(itemType: App.Checkout.AnyItemType): WeddingGiftType {
  if (itemType === 'merchandise') {
    return WeddingGiftType.SHOP
  }

  return WeddingGiftType.GIFT_CARD
}

export function isWeddingGiftRegistryItemSupported(itemType: App.Checkout.AnyItemType): boolean {
  const category = getWeddingGiftCategory(itemType)
  if (!category) {
    return false
  }

  const type = getWeddingGiftType(itemType)
  return !DISABLED_WEDDING_GIFT_TYPES.has(type)
}

export function getWeddingGiftImageId(item: CartItemData): string | undefined {
  if (item.itemType === CHECKOUT_ITEM_TYPE_FLIGHT) {
    return DEFAULT_CUSTOM_OFFER_FLIGHT_IMAGE_ID
  }

  return item.roomImage?.id
}

export function getWeddingGiftTitle(item: CartItemData): string | undefined {
  const titleParts: Array<string> = []

  if (item.sectionHeading) {
    let title = item.sectionHeading
    if (item.itemType === 'flight' && item.locationHeading) title += ' to ' + item.locationHeading

    titleParts.push(title)
  }
  if (item.groupHeading) {
    titleParts.push(item.groupHeading)
  }

  const title = titleParts.join(' - ')
  if (title.length > 0) {
    return title
  }
}

export function getWeddingGiftAmount(item: CartItemData, cartItem?: App.Checkout.AnyItem): number | undefined {
  if (item.itemTotals) {
    if (item.itemTotals.price > 0) return item.itemTotals.price
    if (item.itemTotals.memberPrice > 0) return item.itemTotals.memberPrice
  }

  if (cartItem && isExperienceItem(cartItem)) {
    const itemTotal = cartItem.total ?? 0
    const memberTotal = cartItem.memberTotal ?? 0
    if (itemTotal > 0) return itemTotal
    if (memberTotal > 0) return memberTotal
  }
}
